import { action, Action, State } from 'easy-peasy';

export enum LanguageMenuScreen {
  Root = 'Root',
  Subtitles = 'Subtitles',
  Audio = 'Audio',
  Options = 'Options',
  FontSize = 'FontSize',
  FontColor = 'FontColor',
}

const backTargets: Record<LanguageMenuScreen, LanguageMenuScreen> = {
  [LanguageMenuScreen.Root]: LanguageMenuScreen.Root,
  [LanguageMenuScreen.Subtitles]: LanguageMenuScreen.Root,
  [LanguageMenuScreen.Audio]: LanguageMenuScreen.Root,
  [LanguageMenuScreen.Options]: LanguageMenuScreen.Subtitles,
  [LanguageMenuScreen.FontSize]: LanguageMenuScreen.Options,
  [LanguageMenuScreen.FontColor]: LanguageMenuScreen.Options,
};

export interface LanguageMenuState {
  visible: boolean;
  screen: LanguageMenuScreen;
  setVisible: Action<LanguageMenuState, boolean>;
  navigateTo: Action<LanguageMenuState, LanguageMenuScreen>;
  navigateBack: Action<LanguageMenuState>;
}

export const initialState: State<LanguageMenuState> = {
  visible: false,
  screen: LanguageMenuScreen.Root,
};

export const languageMenuState: LanguageMenuState = {
  ...initialState,

  setVisible: action((state, visible) => {
    state.visible = visible;
    if (visible) {
      state.screen = LanguageMenuScreen.Root;
    }
  }),

  navigateTo: action((state, screen) => {
    state.screen = screen;
  }),

  navigateBack: action((state) => {
    state.screen = backTargets[state.screen];
  }),
};
